var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('MainSection'),_vm._l((_vm.sections),function(i,ind){return _c('Section',{key:ind,attrs:{"title":i.title,"text":i.text,"imgSrc":i.imgSrc,"reverse":i.reversed}})}),_c('EndSection'),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }